const messagesES = {
    code: "es",
    messages: {
        alpha: (field) => `${field} solo puede contener letras`,
        alpha_dash: (field) => `${field} el campo puede contener letras y guiones (-) o guiones bajos (_)`,
        alpha_num: (field) => `${field} solo puede contener letras y números`,
        alpha_spaces: (field) => `${field} solo las letras pueden contener espacios`,
        between: (field, min, max) => `${field} ${min} con ${max} debe estar en el rango`,
        digits: (field, length) => `${field} sayısal ve ${length} basamaklı olmalıdır`,
        confirmed: (field) => `${field} la verificación es incorrecta`,
        dimensions: (field, width, height) => `${field} área ${width} con píxel ${height} debe estar entre píxeles`,
        email: (field) => `${field} El campo debe ser un correo electrónico válido`,
        excluded: (field) => `${field} Introduzca un valor válido en el campo`,
        ext: (field) => `${field} el campo debe ser un archivo válido`,
        image: (field) => `${field} el campo debe ser un archivo de imagen`,
        oneOf: (field) => `${field} Introduzca un valor válido en el campo`,
        max: (field, length) => `${field} área ${length} no más de un carácter`,
        max_value: (field, max) => `${field} área ${max} debe ser un valor de o menos`,
        mimes: (field) => `${field} debe ser un archivo valido`,
        min: (field, length) => `${field} área por lo menos ${length} se debe ingresar el caracter`,
        min_value: (field, min) => `${field} área ${min} debe ser un valor de o más`,
        numeric: (field) => `${field} Introduzca un valor numérico en el campo`,
        regex: (field) => `${field} el formato no es válido`,
        required: (field) => `${field} se requiere espacio`,
        required_if: (field) => `${field} se requiere espacio`,
        size: (field, size) => `${field} área ${size} Debe ser inferior a KB`,
    },
};

export default messagesES;



// WEBPACK FOOTER //
// ./src/language/validationMessagesES.js